'use client';

import selectCategoryInTopNavigationTrigger from '@coolblue-development/ga4-events/triggers/TopNavigation/selectCategoryInTopNavigationTrigger';
import selectHomeButtonTrigger from '@coolblue-development/ga4-events/triggers/TopNavigation/selectHomeButtonTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import {
  TopNavigation as TopNavigationPattern,
  TopNavigationItem
} from '@coolblue-development/next-patterns/client';
import { ProductNavigationNode } from '@features/product-page/typings';

export type TopNavigationProps = {
  items: ProductNavigationNode[];
};

export default function ClientTopNavigation({ items = [] }: TopNavigationProps) {
  const { trackEvent } = useAnalytics();

  const mappedTopNavigationItems: TopNavigationItem[] = items.map((item, index) => {
    const params = {
      index: index + 1, // 1-based index for tracking
      total_indices: items.length,
      url: item.title,
      redirect: item.url
    };

    return {
      id: item.id,
      title: item.title,
      url: item.url,
      urlIndexable: item.urlIndexable || false,
      onClick: () => {
        trackEvent(selectCategoryInTopNavigationTrigger(params));
      }
    };
  });

  const onClickHome = () => {
    trackEvent(selectHomeButtonTrigger());
  };

  return <TopNavigationPattern items={mappedTopNavigationItems} onClickHome={onClickHome} />;
}
